module.exports = __webpack_public_path__ + "static/media/egeos_logo.a5b3367c.png";